import React from "react";
import { ProductImageComponent } from "./ProductImageComponent";
// import ProductVideoComponent from "./ProductVideoComponent";

type OverlayProps = {
  imageSrc: string;
  alt: string;
  videoSrc?: string | null;
  delay?: number;
  loopDelay?: number;
};

function areOverlayPropsEqual(prev: OverlayProps, next: OverlayProps) {
  return (
    prev.imageSrc === next.imageSrc &&
    prev.alt === next.alt &&
    prev.videoSrc === next.videoSrc &&
    prev.delay === next.delay &&
    prev.loopDelay === next.loopDelay
    // prev.previewTime === next.previewTime &&
    // prev.segments === next.segments
  );
}

const ProductMediaOverlay: React.FC<OverlayProps> = ({ imageSrc, alt, videoSrc, delay, loopDelay }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        borderRadius: "inherit",
      }}
    >
      <ProductImageComponent src={imageSrc} alt={alt} />
      {/* video playback disabled on product cards
      {videoSrc && <ProductVideoComponent src={videoSrc} delay={delay} loopDelay={loopDelay} />}
      */}
    </div>
  );
};

export default React.memo(ProductMediaOverlay, areOverlayPropsEqual);
